/**
 * Marcas de "este visitante es un guru en proceso, no un usuario cualquiera".
 *
 * Las usa GuruLegalGate para dejar leer /terms-guru y /mentor-agreement antes
 * de que exista una cuenta: nadie puede aceptar lo que no puede abrir.
 *
 * Hay dos marcas, con origen distinto:
 *   - `validated`: la escribe GuruRegisterPage cuando la edge function
 *     confirmó el token de la invitación. Es el flujo de siempre.
 *   - `preview`: la escribe /invitacion. Esa página es la herramienta de
 *     venta, y desde 2026-08-20 enlaza los documentos legales para que el
 *     invitado los revise ANTES de dejar su correo. Sin esta marca, esos
 *     links caían en la pantalla de bloqueo del gate, que es justo lo
 *     contrario de la transparencia que la pieza promete.
 *
 * Viven en sessionStorage, así que mueren al cerrar la pestaña. No son un
 * control de seguridad —se pueden escribir desde la consola— y no pretenden
 * serlo: el contenido no es secreto, es el contrato que todo guru termina
 * firmando. Lo que evitan es que esas URLs circulen y que alguien ajeno a la
 * relación aterrice en un documento que no le corresponde.
 *
 * Viven en su propio archivo (y no junto al componente) para no romper el
 * fast refresh de Vite, que pide que un módulo de componentes exporte solo
 * componentes.
 */
const INVITE_OK_KEY = 'gurumba:guru_invite_ok';
const INVITE_PREVIEW_KEY = 'gurumba:guru_invite_preview';

function write(key: string): void {
  try {
    sessionStorage.setItem(key, '1');
  } catch {
    // Safari en modo privado puede tirar acá. Sin la marca, el prospect ve la
    // pantalla del gate, que explica cómo seguir.
  }
}

function read(key: string): boolean {
  try {
    return sessionStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function markGuruInviteValidated(): void {
  write(INVITE_OK_KEY);
}

export function hasValidatedGuruInvite(): boolean {
  return read(INVITE_OK_KEY);
}

/** La marca el microsite /invitacion al montarse. */
export function markGuruInvitePreview(): void {
  write(INVITE_PREVIEW_KEY);
}

export function hasGuruInvitePreview(): boolean {
  return read(INVITE_PREVIEW_KEY);
}
